module.exports = __webpack_public_path__ + "img/w54b.3587ed06.jpg";